import React from 'react';
import classNames from 'classnames';

import CustomLink from 'components/Common/CustomLink/CustomLink';
import ChevronLeft from 'components/Common/Icons/ChevronLeft';

import styles from './CheckoutTitlePage.module.scss';

type Props = React.PropsWithChildren<{
  title: string;
  goTo: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  classes?: Partial<{
    container: string;
  }>;
}>;

export default function CheckoutTitlePage({
  children,
  title,
  goTo,
  onClick,
  classes,
}: Props): JSX.Element {
  return (
    <div className={classNames(styles.sectionTitle, classes?.container)}>
      <CustomLink
        to={goTo}
        onClick={e => onClick && onClick(e)}
        className={styles.backShipping}
      >
        <ChevronLeft />
      </CustomLink>
      <h1>{title}</h1>
      {children}
    </div>
  );
}
